import { Injectable, inject } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { Cmg1003ApplicationInfoQuery } from '../application-info/application-info.query';
import { BorrowerModel } from '../../cmg-1003/models';
import { SessionStore } from '../../core/state';
import { iStoreActions } from '../core/store-actions.interface';

export interface Cmg1003BorrowerState extends EntityState<BorrowerModel, number> {
  primaryBorrowerId: number;
}

function createInitialState(): BorrowerModel {
  return <BorrowerModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-borrower-store', idKey: 'borrowerId' })
export class Cmg1003BorrowerStore extends EntityStore<Cmg1003BorrowerState> implements iStoreActions<Cmg1003BorrowerState> {
  private readonly _sessionStore = inject(SessionStore);

  private _initValue: BorrowerModel[] = [];
  constructor() {
    super(createInitialState());
  }

  override akitaPreAddEntity(borrower: BorrowerModel) {
    if (!borrower.dob) {
      borrower.dob = null;
    }
    borrower.isPrimaryBorrower = Cmg1003ApplicationInfoQuery.instance.isPrimaryBorrower(borrower.borrowerId);
    if (borrower.priorAddresses && borrower.priorAddresses.length > 0) {
      borrower.priorAddresses.forEach((t) => (t.isDeleted = false));
    }
    this._initValue.push(JSON.parse(JSON.stringify(borrower)));
    return borrower;
  }

  override akitaPreUpdateEntity(_: Readonly<BorrowerModel>, nextEntity: any): BorrowerModel {
    this._sessionStore.update({ lastUpdatedDateTime: Date.now() });
    return nextEntity;
  }

  get initialValue() {
    return this._initValue;
  }
}
